export default __webpack_public_path__ + "static/media/content-section_text-only.d952709d.svg";